export default "__VITE_ASSET__BPw79Uh6__"